export default __webpack_public_path__ + "static/media/roboto-v27-latin-italic.c8864b37.woff";